module.exports = __webpack_public_path__ + "img/kmlookbook8web.cac5c096.jpg";